/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosDesc } from "@components/elements/molecules/title-desc-stack";
import { CosmosEnumCountryCodes } from "@cosmos/hygraph-schema";
import { useAccountCountry, useGeo } from "@cosmos/next-hooks";
import { css, cx } from "@panda/css";

export interface LegalBannerProps {
	banner?: string | null;
	bannerCountryCodes?: string | null;
}

const styles = css({
	padding: "eds.dimension.20",
	display: "flex",
	justifyContent: "center",
	background: "eds.background.elevated.high.default",
});

export const LegalBanner = ({ banner, bannerCountryCodes }: LegalBannerProps): React.JSX.Element | null => {
	const accountCountry = useAccountCountry();
	const { geo, isLoading: geoLoading } = useGeo();

	if (!banner || !banner.replace(/\s/g, "")) {
		return null;
	}

	let country: string = CosmosEnumCountryCodes.Us;
	if (geo && !geoLoading && geo.country) {
		country = geo?.country;
	}
	const countryToUse = accountCountry || country;

	const requiresCountryCheck = Boolean(countryToUse && bannerCountryCodes);

	let countryWhitelisted = false;
	if (requiresCountryCheck && bannerCountryCodes) {
		const bannerCountryCodesArray = bannerCountryCodes.replace(/\s/g, "").split(",");
		for (let i = 0; i < bannerCountryCodesArray.length; i++) {
			const code = bannerCountryCodesArray[i].toLowerCase();
			if (countryToUse.toLowerCase() === code) {
				countryWhitelisted = true;
				break;
			}
		}
	}

	if (requiresCountryCheck && !countryWhitelisted) {
		return null;
	}

	return (
		<div className={cx("legal-banner", styles)}>
			<CosmosDesc description={{ html: banner, color: "eds.text.primary" }} />
		</div>
	);
};
